import { render, staticRenderFns } from "./CreateQuestionForm.vue?vue&type=template&id=3e68adff&scoped=true&"
import script from "./CreateQuestionForm.vue?vue&type=script&lang=js&"
export * from "./CreateQuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuestionForm.vue?vue&type=style&index=0&id=3e68adff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e68adff",
  null
  
)

export default component.exports